import { stdcheckCommonEnvironment } from '@environments/stdcheck/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the STDcheck site, in production environment.
 */
export const environment: AppEnvironment = {
  ...stdcheckCommonEnvironment,
  production: true,
  apiUrl: 'https://api.analytecare.com',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyAVUfSfF7Tc_7UcnlVTF0U6-cboVLRLpsA',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://www.stdcheck.com',
    termsOfService: 'https://www.stdcheck.com/terms-of-service.php',
    myAccount: 'https://my-account.stdcheck.com',
    tests: 'https://www.stdcheck.com/std-test-pricing.php',
    notFound: 'https://www.stdcheck.com/404',
  },
};
